import {
  CreateAssetRequestDto,
  CreateAssetResponseDto,
  GetInstrumentsForCreateAssetResponseDto,
  ReadAssetsRequestDto,
  ReadAssetsResponseDto,
  UpdateAssetsRequestDto,
  UpdateAssetsResponseDto,
} from '@sparling/financial-common'
import axios, { AxiosRequestConfig } from 'axios'
import { isNil } from 'lodash'

export const fetchAssets = async (
  { token, ...params }: ReadAssetsRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadAssetsResponseDto> => {
  const response = await axios.get<ReadAssetsResponseDto>(`${process.env.REACT_APP_SERVER_URL}/crm/assets`, {
    params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  })
  return response.data
}

export const getInstrumentsForCreateAsset = async (
  { token, search }: { search?: string } & { token: string },
  options: AxiosRequestConfig = {},
): Promise<GetInstrumentsForCreateAssetResponseDto[]> => {
  const response = await axios.get<GetInstrumentsForCreateAssetResponseDto[]>(
    `${process.env.REACT_APP_SERVER_URL}/crm/assets/instruments-for-create`,
    {
      params: { search },
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const createAsset = async (
  { token, ...data }: CreateAssetRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<CreateAssetResponseDto> => {
  const response = await axios.post<CreateAssetResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/assets/create`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const updateAssets = async (
  { token, ...data }: UpdateAssetsRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<UpdateAssetsResponseDto> => {
  const response = await axios.post<UpdateAssetsResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/assets/update`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}
